import React, { ReactNode } from 'react'

interface MenuProps {
  children: ReactNode
}

const Menu: React.FC<MenuProps> = ({ children }) => {
  return (
    <div
      className='menu-container flex flex-row justify-end gap-4'
      role='menu'
    >
      {children}
    </div>
  )
}

export default Menu
